// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getProjectSummaryWeekly(projectId: string, startDate: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/executionstatus?start_date=${startDate}`);
}
